'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSyncProblem = function MdSyncProblem(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.4 21.6v-10h3.2v10h-3.2z m16.6-15l-3.9 4c2.4 2.5 3.9 5.7 3.9 9.4 0 6.3-4.2 11.4-10 12.9v-3.4c3.9-1.4 6.6-5.1 6.6-9.5 0-2.7-1.1-5.2-2.8-7l-3.8 3.6v-10h10z m-16.6 21.8v-3.4h3.2v3.4h-3.2z m-13.4-8.4c0-6.2 4.2-11.4 10-12.9v3.5c-3.9 1.3-6.6 5-6.6 9.4 0 2.7 1.1 5.2 2.9 7l3.7-3.6v10h-10l3.9-4c-2.4-2.4-3.9-5.7-3.9-9.4z' })
        )
    );
};

exports.default = MdSyncProblem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/sync-problem.js
// module id = 3393
// module chunks = 0